




























import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";

@Component

export default class PrivateContactComponent extends Vue {
    items = [];

    mounted() {
        this.$services.contact.getAllContact()
            .then((resp) => {
                this.items = resp;
            });
    }
}
